import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import type { ProjectSummary } from "../../api/projectsApi";
import { appPaths } from "../../shared/routing/appPaths";
import Chip from "../../ui/feedback/Chip";

/**
 * A project's place relative to the DMW basis on the projects overview: the core itself is
 * marked as protected basis tooling (F62); another project shows the basis its pins name,
 * with the release of the DMW process ontology it holds, and the review that would swap in
 * a newer one when it waits (F63, H-09). A project that pins none shows nothing (BA11-05).
 */
export default function ProjectBasis({ project }: { project: ProjectSummary }) {
  const { t } = useTranslation();
  if (project.installationOwned) {
    return (
      <Chip tone="warning" className="shrink-0 font-normal" title={t("projects.basis.coreHint")} icon={<LockClosedIcon className="h-3 w-3" aria-hidden="true" />}>
        {t("projects.basis.core")}
      </Chip>
    );
  }
  const { basis } = project;
  if (basis === null) return null;
  return (
    <span className="flex shrink-0 items-center gap-1.5">
      <Chip className="font-normal" title={t("projects.basis.inheritedHint")}>
        {basis.release === null ? t("projects.basis.inherited") : t("projects.basis.inheritedRelease", { release: basis.release })}
      </Chip>
      {basis.updateChangeSetId === null ? null : (
        <Link to={appPaths.review(basis.updateChangeSetId)} className="app-link text-xs">
          {t("projects.basis.update")}
        </Link>
      )}
    </span>
  );
}
